import React from 'react'
import ReactPlayer from 'react-player'

import TicTacToeArch from "./../../../assets/tictactoe-arch.png"

import videoTicTacToe from "./../../../assets/videoTictactoe.mp4"

function Tictactoe() {
  return (
    <>
    <div className='px-6 py-6 overflow-scroll'>

<div className=' border-2 border-black rounded-xl flex justify-center mb-8'>

<ReactPlayer url={videoTicTacToe} playing={true} width={1000}   controls={true}/>

</div>


<h1 className='font-bold text-xl mb-2'>Architecture of Tic Tac Toe Spring app</h1>

<a href={TicTacToeArch} target='_blank'>
  
<img class src={TicTacToeArch}/>
  </a>


<div className='flex flex-col gap-6'>
    
<h1 className='text-2xl font-bold mt-6'>Summary</h1>
<p> This project implements a scalable Tic-Tac-Toe game using a microservices architecture with four core services: User Service, Game Service, Matchmaking Service, and API Gateway. These services are designed to work together in a seamless, real-time multiplayer environment. </p>

   <p> <span className='text-xl font-bold'>API Gateway:</span> The API Gateway routes traffic to the appropriate services and provides session management through authentication. It checks user sessions and allows access to all /auth/** routes (registering, logging in) via the User Service. For other requests, it verifies the session by checking the Redis database before granting access. It also provides the necessary routing for the other services to communicate efficiently. </p>

    <p> <span className='text-xl font-bold'>User Service:</span>  This service handles user authentication and profile management, including registration, login, and tracking game statistics such as wins, losses, and draws. It interacts with Redis to manage session data for the user, ensuring proper state persistence across services. </p>

 <p> <span className='text-xl font-bold'>Matchmaking Service:</span> The Matchmaking Service is responsible for managing game sessions. It allows users to create and join games. When a player creates a game, they can share the gameSessionID with others. The service utilizes Redis Pub/Sub to notify the frontend when a game is ready by sending a notification to the subscribed channel. This allows the frontend to display the notification dynamically without needing to reload the page. It also manages game deletion and interaction with the Game Service to create actual game sessions. </p>

   <p> <span className='text-xl font-bold'>Game Service:</span> The Game Service is the core of the gameplay experience. It manages the Tic-Tac-Toe game logic, handling each game session and the corresponding WebSocket connections. Every game is stored as a session in Redis. The service uses WebSockets to communicate moves between players, with messages in the format &#123;userID: 2, message: [0,3]&#125; representing user actions. The service ensures that only active participants in the game can make moves by verifying that the user is logged in and has joined the game session. Additionally, the Game Service integrates spectator mode functionality, where users can observe games without being able to make moves. Like the Matchmaking Service, it uses Redis for session management and state persistence.</p>
    </div>

    </div>

</>    



  )
}

export default Tictactoe